import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectPRLoader } from 'src/store/selectors/PropertyLoader';
import NotesWithState from 'src/components/NotesNewWithState/NotesWithState';
import Loader from 'src/components/Loader';
import {
  useItemNotesActionsFromContext,
  useItemNotesDataFromContext,
} from 'src/pages/Item/Context/ItemNotesProvider';

const ItemNotes = ({ item, onFetchItemData }: any) => {
  const loader = useSelector(selectPRLoader);
  const { notes, loadingNotesDocs } = useItemNotesDataFromContext();

  const { fetchNotes, saveNote, updateNote, deleteNote, clearSearch } =
    useItemNotesActionsFromContext();

  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    clearSearch();
    fetchNotes(item.id);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, [item.id]);

  const handleSaveNote = async (note: any) => {
    await saveNote(note, item.id);
    await onFetchItemData();
  };

  const handleUpdateNote = async (note: any) => {
    await updateNote(note, item.id);
    await onFetchItemData();
  };

  const handleDeleteNote = async (noteToDelete: any) => {
    await deleteNote(noteToDelete, item.id);
    await onFetchItemData();
  };

  return loader || loading || loadingNotesDocs ? (
    <Loader />
  ) : (
    <NotesWithState
      notes={notes}
      onSaveNote={handleSaveNote}
      onDeleteNote={handleDeleteNote}
      onEditNote={handleUpdateNote}
      breadcrumb={item.name}
      from="inventoryItems"
    />
  );
};

export default ItemNotes;
